import * as React from 'react'
import PropTypes from 'prop-types'
import getApiClient from 'utils/apiClient'

const KlaviyoTrack = (props) => {
  const { queryString } = props

  const apiClient = getApiClient()

  React.useEffect(() => {
    const track = async () => {
      await apiClient.klaviyoTrack(queryString)
    }

    track()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

KlaviyoTrack.propTypes = {
  queryString: PropTypes.string,
}

export default KlaviyoTrack
